import gql from "graphql-tag";

export const GET_SUB_MODELS = gql`
  query getSubModels($year: String!, $make: String!, $model: String!) {
    getSubModels(year: $year, make: $make, model: $model)
  }
`;
